export default {
  title: 'Setări bacșiș',
  form: {
    has_tips: {
      label: 'Permite bacșișuri',
    },
    default_tip_percentage: {
      label: 'Rată bacșiș pre-selectată',
      tooltip: 'Rata care va fi pre-selectată pentru client când ajunge la ecranul de plată',
    },
    is_tip_hidden_on_receipt: {
      label: 'Bacșișurile nu sunt vizibile pe bonuri',
      tooltip:
        'Când este activat, ascunde bacșișurile pe bonurile tipărite și în fereastra de informații despre comandă',
    },
  },
  buttons: {
    save: 'Salvează',
  },
  toasts: {
    failed_to_save_changes: 'Nu s-au putut salva modificările',
    changes_got_saved: 'Modificările au fost salvate',
  },
};
